import { createSelector } from 'reselect'
import { selectMailboxesById } from './selectMailboxesById'

export const selectMailboxIds = createSelector(selectMailboxesById, byId =>
  Object.keys(byId)
)
